export const BUILD_TIME_HELP_PANELS_ENABLED = false;

/**
 * Single feature flag governing ALL EPO help (Info) panels — seller and buyer.
 * Resolved host-side from the build-time flag OR the `epoHelpPanels` debug toggle.
 * The renewal feature flag still gates the renewal tab/step themselves; this flag
 * only controls whether their Info links and help panels render.
 */
export const isHelpPanelsEnabled = (debugPanelHelpPanels: boolean): boolean => BUILD_TIME_HELP_PANELS_ENABLED || debugPanelHelpPanels;
